import { StatusContainer } from "./style";

interface IProps {
  status: string;
  width?: string;
}
export function StatusRecebeBoleto({ status, width }: IProps) {
  const handleStatus = (status: string) => {
    if (status === "Sim") {
      return {
        backgroundColor: "#DBFFF6",
        color: "#10AC85",
        border: "1px solid #10AC85",
      };
    }

    return {
      backgroundColor: "#FFEFCC",
      color: "#FF9F42",
      border: "1px solid #FF9F42",
    };
  };

  return (
    <StatusContainer width={width} style={handleStatus(status)}>
      {status}
    </StatusContainer>
  );
}
